import { render, staticRenderFns } from "./preference.vue?vue&type=template&id=002ade48&"
import script from "./preference.ts?vue&type=script&lang=ts&"
export * from "./preference.ts?vue&type=script&lang=ts&"
import style0 from "./preference.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports